export default __webpack_public_path__ + "static/media/airplane.0228bc83.png";